<div>
    <div *ngIf="pharmacyIsSupplier; else pharmacyIsBuyer" class="box">
        <app-supplier-buyer-card 
            [data]="supplier" 
            [readOnly]="readOnly"
            [type]="supplier?.orderParty?.type || OrderPartyTypeEnum.Supplier"
            [isPharmacy]="true"
            (addedModified)="supplierAddedModified($event)" #supplierEl>
        </app-supplier-buyer-card>
        <img class="mx-4" src="assets/icons/icon-arrow-transition.svg" alt="asc" />
        <app-supplier-buyer-card 
            [type]="buyer?.orderParty?.type || OrderPartyTypeEnum.Buyer"
            [data]="buyer" [readOnly]="readOnly" 
            [autocompleteData]="buyers"
            (addedModified)="buyerAddedModified($event)" 
            (selected)="buyerSelected($event)"
            (partyRemoved)="buyerRemoved()" #buyerEl>
        </app-supplier-buyer-card>
    </div>
    <ng-template #pharmacyIsBuyer>
        <div class="box">
            <app-supplier-buyer-card 
                [data]="supplier" 
                [type]="OrderPartyTypeEnum.EdiSupplier"
                [readOnly]="readOnly"
                [autocompleteData]="ediSuppliers" 
                (selected)="ediSupplierSelected($event)" 
                (partyRemoved)="ediSupplierRemoved()"
                (addedModified)="supplierAddedModified($event)" #supplierEl>
            </app-supplier-buyer-card>
            <img class="mx-4" src="assets/icons/icon-arrow-transition.svg" alt="asc" />
            <app-supplier-buyer-card 
                [type]="OrderPartyTypeEnum.EdiBuyer" 
                [data]="buyer" [readOnly]="readOnly"
                [isPharmacy]="true"
                (addedModified)="buyerAddedModified($event)"
                #buyerEl>
            </app-supplier-buyer-card>
        </div>
      
    </ng-template>

</div>